export default __webpack_public_path__ + "static/media/logo.c9ec480c.svg";